import React from 'react';
import { connect } from 'react-redux';

import { Theme, createStyles, withStyles, Tooltip, Grid } from '@material-ui/core';
import { FormControl } from '@material-ui/core';

import addIcon from '../../../../../assets/add.svg';
import style from '../../../../common/commonComponentsStyle.module.css';
import commonStyles from '../../../../common/common.module.css';
import DeliveryCompany from '../../../../../models/DeliveryCompany';
import ForwarderModel from '../../../../../models/ForwarderAwb';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import forwarderRemote from '../../../../../api/forwarderRemote';

const iconFontSize = 40;
const useStyles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    helperText: {
      color: 'red',
      marginLeft: '10px'
    },
    selectdropdown: {
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control': {
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
        minHeight: '30px !important',
        boxShadow: 'none',
        '&:hover': {
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px'
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator': {
        display: 'none'
      },
      '& .css-g1d714-ValueContainer': {
        padding: '0 8px'
      },
      '& .css-1wa3eu0-placeholder': {
        lineHeight: 1,
        fontSize: '12px',
      },
    },
    error:{
      fontSize: '10px',
      color: 'red'
    },
    addForwarder: {
      width: '30px',
    },
  });

interface ForwarderDropDownProps {
  classes: any;
  items: Array<DeliveryCompany | ForwarderModel>;
  value: number | undefined;
  openModal: () => void;
  allowedToChange?: boolean;
  onChange: (event: any) => void;
  valiant?: string;
  labelText: string;
  type: 'truckingCompany' | 'fwdCompany';
  error?: string;
  onClick?: (event: any) => void;
  hasCreateNewCompany?: boolean;
  isEditMode: boolean;
  isAddMode: any;
  stationValue?: string;
  ghaId?: number;
};

interface Option {
  value: number;
  label: string;
};

const forwarderDropDown = (props: ForwarderDropDownProps) => {

  const { classes } = props; 
  const options: Array<Option> = props.items.map((item: any) => (
    {
      value: item.forwarder_location_id,
      label: item.name
    }
  ));
  const getForwarderValue = (): Option => {
    const value: Array<Option> = options.filter((fwd: any) => fwd.value === props.value);
    if (value.length > 0) return value[0];
    if (props.type === 'fwdCompany' && props.value) {
      if (props.valiant) {
         return { value: props.value, label: props.valiant };
      }
      return { value: props.value, label: `Selected ID ${props.value}` };
    }
    return value[0];
  }
  const disabled = (props.type === 'truckingCompany' && !props.allowedToChange)?  true : false;
  const onClick = (props.type === 'truckingCompany')? (props.allowedToChange ? props.openModal : undefined ) : props.openModal;
  const styleSelect:  string = props.type === 'fwdCompany' ? classes.select : '';
  const selectValue: any = props.value ? getForwarderValue() : null;

  const loadOptions = async (inputValue: string) => {
    try {
      const res = await forwarderRemote.getForwaderByRelevance({ 
        name: inputValue || undefined,
        iata_code: props.stationValue,
        ghaId: props.ghaId
      });
      if (res && res.result) {
        return res.result.map((item: any) => ({
          value: item.forwarder_location_id,
          label: item.name,
          forwarderId: item.id
        }));
      }
      return [];
    } catch (e) {
      return [];
    }
  };

  return (
    <div className={ style.fwdListWrapper }>
      <Grid container>
        <Grid item md={6} xs={10}>
          <FormControl variant="outlined" className={ `${ style.fwdprFields } ${ classes.selectdropdown }` }>
            <label className={ commonStyles.inputLabel }>List of forwarders</label>
            { props.type === 'fwdCompany' ? (
              <AsyncSelect
                key={props.stationValue}
                cacheOptions
                defaultOptions={true}
                loadOptions={loadOptions}
                onChange={ props.onChange }
                isDisabled={ disabled || props.isEditMode }
                className={ styleSelect }
                value={ selectValue }
                placeholder={ props.labelText }
                onClick={ props.onClick }
              />
            ) : (
              <Select
                onChange={ props.onChange }
                isDisabled={ disabled || props.isEditMode }
                options={ options }
                className={ styleSelect }
                value={ selectValue }
                placeholder={ props.labelText }
                onClick={ props.onClick }
              />
            )}
          </FormControl>
        </Grid>
        <Grid item md={6} xs={2}>
          { !props.hasCreateNewCompany && !props.isEditMode &&
            <div className={ `${ style.buttonWrapper } ${ classes.fwdBtn } ${ commonStyles.fColumnEnd }` }>
              <label className={ commonStyles.transparent }>-</label>
              <Tooltip title="Add new forwarder to the list">
                <img src={addIcon} alt="Add Forwarder" onClick={ onClick } className={ classes.addForwarder }/>
              </Tooltip>
            </div>
          }
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isEditMode: state.manualEntryEdit.isEditMode,
    isAddMode: state.manualEntryAdd,
    ghaId: state.ghaInfo ? state.ghaInfo.id : undefined
  }
}

export default withStyles(useStyles)(connect(mapStateToProps, {})(forwarderDropDown));
